module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Heroes & Villains: Origins","short_name":"HV Origins","start_url":"/","background_color":"#000000","theme_color":"#000000","display":"browser","icon":"src/images/icon.png","cache_busting_mode":"name","legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6e8a307edf8800cb1832118c4bfcf466"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
